import '@/helpers/plugins/polyfills';
import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import '@/helpers/directives';
import '@/helpers/plugins/register-global-components';
import '@/helpers/plugins/vendors';
import '@/media/sass/main.sass';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
